module.exports = __webpack_public_path__ + "static/media/XRCenter_christiaanWauben-5.ac38b8d1.jpg";